import { render, staticRenderFns } from "./ConciergeBookingItems.vue?vue&type=template&id=2dcb2d36&scoped=true"
import script from "./ConciergeBookingItems.ts?vue&type=script&lang=ts&external"
export * from "./ConciergeBookingItems.ts?vue&type=script&lang=ts&external"
import style0 from "./ConciergeBookingItems.vue?vue&type=style&index=0&id=2dcb2d36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb2d36",
  null
  
)

export default component.exports